package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets2 {
  internal val _12_yeshaaya_49_txt: AssetResource by lazy { init__12_yeshaaya_49_txt() }

  internal val _12_yeshaaya_50_txt: AssetResource by lazy { init__12_yeshaaya_50_txt() }

  internal val _12_yeshaaya_51_txt: AssetResource by lazy { init__12_yeshaaya_51_txt() }

  internal val _12_yeshaaya_52_txt: AssetResource by lazy { init__12_yeshaaya_52_txt() }

  internal val _12_yeshaaya_53_txt: AssetResource by lazy { init__12_yeshaaya_53_txt() }

  internal val _12_yeshaaya_54_txt: AssetResource by lazy { init__12_yeshaaya_54_txt() }

  internal val _12_yeshaaya_55_txt: AssetResource by lazy { init__12_yeshaaya_55_txt() }

  internal val _12_yeshaaya_56_txt: AssetResource by lazy { init__12_yeshaaya_56_txt() }

  internal val _12_yeshaaya_57_txt: AssetResource by lazy { init__12_yeshaaya_57_txt() }

  internal val _12_yeshaaya_58_txt: AssetResource by lazy { init__12_yeshaaya_58_txt() }

  internal val _12_yeshaaya_59_txt: AssetResource by lazy { init__12_yeshaaya_59_txt() }

  internal val _12_yeshaaya_60_txt: AssetResource by lazy { init__12_yeshaaya_60_txt() }

  internal val _12_yeshaaya_61_txt: AssetResource by lazy { init__12_yeshaaya_61_txt() }

  internal val _12_yeshaaya_62_txt: AssetResource by lazy { init__12_yeshaaya_62_txt() }

  internal val _12_yeshaaya_63_txt: AssetResource by lazy { init__12_yeshaaya_63_txt() }

  internal val _12_yeshaaya_64_txt: AssetResource by lazy { init__12_yeshaaya_64_txt() }

  internal val _12_yeshaaya_65_txt: AssetResource by lazy { init__12_yeshaaya_65_txt() }

  internal val _12_yeshaaya_66_txt: AssetResource by lazy { init__12_yeshaaya_66_txt() }

  internal val _13_yirmeyah_01_txt: AssetResource by lazy { init__13_yirmeyah_01_txt() }

  internal val _13_yirmeyah_02_txt: AssetResource by lazy { init__13_yirmeyah_02_txt() }

  internal val _13_yirmeyah_03_txt: AssetResource by lazy { init__13_yirmeyah_03_txt() }

  internal val _13_yirmeyah_04_txt: AssetResource by lazy { init__13_yirmeyah_04_txt() }

  internal val _13_yirmeyah_05_txt: AssetResource by lazy { init__13_yirmeyah_05_txt() }

  internal val _13_yirmeyah_06_txt: AssetResource by lazy { init__13_yirmeyah_06_txt() }

  internal val _13_yirmeyah_07_txt: AssetResource by lazy { init__13_yirmeyah_07_txt() }

  internal val _13_yirmeyah_08_txt: AssetResource by lazy { init__13_yirmeyah_08_txt() }

  internal val _13_yirmeyah_09_txt: AssetResource by lazy { init__13_yirmeyah_09_txt() }

  internal val _13_yirmeyah_10_txt: AssetResource by lazy { init__13_yirmeyah_10_txt() }

  internal val _13_yirmeyah_11_txt: AssetResource by lazy { init__13_yirmeyah_11_txt() }

  internal val _13_yirmeyah_12_txt: AssetResource by lazy { init__13_yirmeyah_12_txt() }

  internal val _13_yirmeyah_13_txt: AssetResource by lazy { init__13_yirmeyah_13_txt() }

  internal val _13_yirmeyah_14_txt: AssetResource by lazy { init__13_yirmeyah_14_txt() }

  internal val _13_yirmeyah_15_txt: AssetResource by lazy { init__13_yirmeyah_15_txt() }

  internal val _13_yirmeyah_16_txt: AssetResource by lazy { init__13_yirmeyah_16_txt() }

  internal val _13_yirmeyah_17_txt: AssetResource by lazy { init__13_yirmeyah_17_txt() }

  internal val _13_yirmeyah_18_txt: AssetResource by lazy { init__13_yirmeyah_18_txt() }

  internal val _13_yirmeyah_19_txt: AssetResource by lazy { init__13_yirmeyah_19_txt() }

  internal val _13_yirmeyah_20_txt: AssetResource by lazy { init__13_yirmeyah_20_txt() }

  internal val _13_yirmeyah_21_txt: AssetResource by lazy { init__13_yirmeyah_21_txt() }

  internal val _13_yirmeyah_22_txt: AssetResource by lazy { init__13_yirmeyah_22_txt() }

  internal val _13_yirmeyah_23_txt: AssetResource by lazy { init__13_yirmeyah_23_txt() }

  internal val _13_yirmeyah_24_txt: AssetResource by lazy { init__13_yirmeyah_24_txt() }

  internal val _13_yirmeyah_25_txt: AssetResource by lazy { init__13_yirmeyah_25_txt() }

  internal val _13_yirmeyah_26_txt: AssetResource by lazy { init__13_yirmeyah_26_txt() }

  internal val _13_yirmeyah_27_txt: AssetResource by lazy { init__13_yirmeyah_27_txt() }

  internal val _13_yirmeyah_28_txt: AssetResource by lazy { init__13_yirmeyah_28_txt() }

  internal val _13_yirmeyah_29_txt: AssetResource by lazy { init__13_yirmeyah_29_txt() }

  internal val _13_yirmeyah_30_txt: AssetResource by lazy { init__13_yirmeyah_30_txt() }

  internal val _13_yirmeyah_31_txt: AssetResource by lazy { init__13_yirmeyah_31_txt() }

  internal val _13_yirmeyah_32_txt: AssetResource by lazy { init__13_yirmeyah_32_txt() }

  internal fun values(): List<AssetResource> = listOf(_12_yeshaaya_49_txt, _12_yeshaaya_50_txt,
      _12_yeshaaya_51_txt, _12_yeshaaya_52_txt, _12_yeshaaya_53_txt, _12_yeshaaya_54_txt,
      _12_yeshaaya_55_txt, _12_yeshaaya_56_txt, _12_yeshaaya_57_txt, _12_yeshaaya_58_txt,
      _12_yeshaaya_59_txt, _12_yeshaaya_60_txt, _12_yeshaaya_61_txt, _12_yeshaaya_62_txt,
      _12_yeshaaya_63_txt, _12_yeshaaya_64_txt, _12_yeshaaya_65_txt, _12_yeshaaya_66_txt,
      _13_yirmeyah_01_txt, _13_yirmeyah_02_txt, _13_yirmeyah_03_txt, _13_yirmeyah_04_txt,
      _13_yirmeyah_05_txt, _13_yirmeyah_06_txt, _13_yirmeyah_07_txt, _13_yirmeyah_08_txt,
      _13_yirmeyah_09_txt, _13_yirmeyah_10_txt, _13_yirmeyah_11_txt, _13_yirmeyah_12_txt,
      _13_yirmeyah_13_txt, _13_yirmeyah_14_txt, _13_yirmeyah_15_txt, _13_yirmeyah_16_txt,
      _13_yirmeyah_17_txt, _13_yirmeyah_18_txt, _13_yirmeyah_19_txt, _13_yirmeyah_20_txt,
      _13_yirmeyah_21_txt, _13_yirmeyah_22_txt, _13_yirmeyah_23_txt, _13_yirmeyah_24_txt,
      _13_yirmeyah_25_txt, _13_yirmeyah_26_txt, _13_yirmeyah_27_txt, _13_yirmeyah_28_txt,
      _13_yirmeyah_29_txt, _13_yirmeyah_30_txt, _13_yirmeyah_31_txt, _13_yirmeyah_32_txt)
}

private fun init__12_yeshaaya_49_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-49.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-49.txt")

private fun init__12_yeshaaya_50_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-50.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-50.txt")

private fun init__12_yeshaaya_51_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-51.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-51.txt")

private fun init__12_yeshaaya_52_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-52.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-52.txt")

private fun init__12_yeshaaya_53_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-53.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-53.txt")

private fun init__12_yeshaaya_54_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-54.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-54.txt")

private fun init__12_yeshaaya_55_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-55.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-55.txt")

private fun init__12_yeshaaya_56_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-56.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-56.txt")

private fun init__12_yeshaaya_57_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-57.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-57.txt")

private fun init__12_yeshaaya_58_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-58.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-58.txt")

private fun init__12_yeshaaya_59_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-59.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-59.txt")

private fun init__12_yeshaaya_60_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-60.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-60.txt")

private fun init__12_yeshaaya_61_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-61.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-61.txt")

private fun init__12_yeshaaya_62_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-62.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-62.txt")

private fun init__12_yeshaaya_63_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-63.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-63.txt")

private fun init__12_yeshaaya_64_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-64.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-64.txt")

private fun init__12_yeshaaya_65_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-65.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-65.txt")

private fun init__12_yeshaaya_66_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-66.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-66.txt")

private fun init__13_yirmeyah_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-01.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-01.txt")

private fun init__13_yirmeyah_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-02.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-02.txt")

private fun init__13_yirmeyah_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-03.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-03.txt")

private fun init__13_yirmeyah_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-04.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-04.txt")

private fun init__13_yirmeyah_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-05.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-05.txt")

private fun init__13_yirmeyah_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-06.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-06.txt")

private fun init__13_yirmeyah_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-07.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-07.txt")

private fun init__13_yirmeyah_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-08.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-08.txt")

private fun init__13_yirmeyah_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-09.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-09.txt")

private fun init__13_yirmeyah_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-10.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-10.txt")

private fun init__13_yirmeyah_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-11.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-11.txt")

private fun init__13_yirmeyah_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-12.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-12.txt")

private fun init__13_yirmeyah_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-13.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-13.txt")

private fun init__13_yirmeyah_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-14.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-14.txt")

private fun init__13_yirmeyah_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-15.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-15.txt")

private fun init__13_yirmeyah_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-16.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-16.txt")

private fun init__13_yirmeyah_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-17.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-17.txt")

private fun init__13_yirmeyah_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-18.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-18.txt")

private fun init__13_yirmeyah_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-19.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-19.txt")

private fun init__13_yirmeyah_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-20.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-20.txt")

private fun init__13_yirmeyah_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-21.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-21.txt")

private fun init__13_yirmeyah_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-22.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-22.txt")

private fun init__13_yirmeyah_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-23.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-23.txt")

private fun init__13_yirmeyah_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-24.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-24.txt")

private fun init__13_yirmeyah_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-25.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-25.txt")

private fun init__13_yirmeyah_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-26.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-26.txt")

private fun init__13_yirmeyah_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-27.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-27.txt")

private fun init__13_yirmeyah_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-28.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-28.txt")

private fun init__13_yirmeyah_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-29.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-29.txt")

private fun init__13_yirmeyah_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-30.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-30.txt")

private fun init__13_yirmeyah_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-31.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-31.txt")

private fun init__13_yirmeyah_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-32.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-32.txt")

public actual val SharedRes.assets.allChapters._12_yeshaaya_49_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_49_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_50_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_50_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_51_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_51_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_52_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_52_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_53_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_53_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_54_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_54_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_55_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_55_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_56_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_56_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_57_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_57_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_58_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_58_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_59_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_59_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_60_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_60_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_61_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_61_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_62_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_62_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_63_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_63_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_64_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_64_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_65_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_65_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_66_txt: AssetResource
  get() = CommonMainAssets2._12_yeshaaya_66_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_01_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_01_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_02_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_02_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_03_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_03_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_04_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_04_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_05_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_05_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_06_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_06_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_07_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_07_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_08_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_08_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_09_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_09_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_10_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_10_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_11_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_11_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_12_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_12_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_13_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_13_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_14_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_14_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_15_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_15_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_16_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_16_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_17_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_17_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_18_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_18_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_19_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_19_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_20_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_20_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_21_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_21_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_22_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_22_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_23_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_23_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_24_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_24_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_25_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_25_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_26_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_26_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_27_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_27_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_28_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_28_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_29_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_29_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_30_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_30_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_31_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_31_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_32_txt: AssetResource
  get() = CommonMainAssets2._13_yirmeyah_32_txt
